

<div class="">
    <div class="flex justify-between items-center">
        <span class="font-bold text-gray flex gap-3">
             <fa-icon [icon]="faBuilding"></fa-icon> Warehouse Zones
        </span>


        <!-- <button *ngxPermissionsOnly="addPermission" (click)="onAdd()" mat-raised-button color="primary" style="background-color: #005590;">
            <mat-icon>add</mat-icon>
            Create Zone
        </button> -->
    </div>
</div>

<div class="">
    <app-paginated-data-table
            [resetTable]="refresh"
            [tableConfigurations]="tableConfiguration"
            [permissions]="permissions"
            (customAction)="onCustomAction($event)"
            [query]="query"
            [pageSize]="5"
            [mapFunction]="mapFunction"
            [additionalVariables]="filters"
            [actionButtons]="actionButtons"
            [upsertAction]="upsertAction"
            [deleteAction]="deleteAction"
    >
    </app-paginated-data-table>
</div>
